/**
 * Consent Survey
 * Reusable survey component that displays all checkboxes for a given survey
 * and writes to the users records when saved
 */
import { Box, Link } from '@mui/material';
import type { FieldProps } from 'formik';
import { Field } from 'formik';
import React from 'react';
import reactStringReplace from 'react-string-replace';

import Checkbox from '@components/Checkbox/index';

interface ILink {
  text: string;
  link: string;
}

interface ConsentFormProps {
  validate?: boolean;
  links?: ILink[];
  error?: string;
  // allowSelectAll?: boolean;
  style?: Record<string, string>;
  name: string;
  text: string[] | string;
  disabled?: boolean;
}

const ConsentSurvey: React.FC<ConsentFormProps> = ({
  validate = false,
  error = '',
  style = {},
  links = [],
  name,
  // allowSelectAll = false,
  text,
  disabled = false,
}) => {
  function injectLink(str: string[] | string) {
    let questionText: React.ReactNode[];
    if (Array.isArray(str)) {
      questionText = str;
    } else {
      questionText = [str];
    }
    links.forEach(({ text, link }, index) => {
      questionText = reactStringReplace(questionText, text, (_match, i) => {
        return (
          <Link
            href={link}
            key={`link-${i}-${index}`}
            rel="noopener noreferrer"
            target="_blank"
            underline="none"
            sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}
          >
            {text}
          </Link>
        );
      });
    });

    return questionText;
  }

  return (
    <Box sx={{ ...style }}>
      <Field name={name} type="checkbox">
        {({ field, form: { handleChange } }: FieldProps<boolean>) => {
          return (
            <Checkbox
              checked={field.value}
              disabled={disabled}
              error={Boolean(validate ? error : '')}
              helperText={validate ? error : ''}
              label={injectLink(text)}
              name={field.name}
              onChange={handleChange}
            />
          );
        }}
      </Field>
    </Box>
  );
};

export default ConsentSurvey;
